import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'attributeKeyTranslate',
    standalone: false
})
export class AttributeKeyTranslatePipe implements PipeTransform {
    private attributeKeyTranslation: { [key: string]: string } = {
        type: 'Werksoort',
        buildingClassification: 'Gebruiksfunctie',
        buildingSubClassification: 'Sub-Gebruiksfunctie',
        vwConcept: 'VolkerWessels Concept',
        sustainabilityClass: 'Duurzaamheid classificatie',
        coreDataProject: 'Kerngegevens project',
        surfaceVVO: 'Oppervlakte VVO',
        surfaceFacade: 'Oppervlakte gevel',
        locationSize: 'Locatie omvang',
        buildingLayersAboveGround: 'Aantal bouwlagen bovengronds',
        buildingLayersUnderGround: 'Aantal bouwlagen ondergronds',
        demolitionSize: 'Omvang sloop',
        remediateSize: 'Omvang saneren',
        readyForConstructionSize: 'Omvang bouwrijp maken',
        readyToLiveSize: 'Omvang woonrijp maken',
        keyFeatures: 'Keyfeatures vastgoed',
        maintanceContractYears: 'Onderhoudscontract aantal jaar',

        // ProjectScope attributes
        totalBuildingObjects: 'Aantal woningen, appartementen, etc',
        surfaceLot: 'Oppervlakte perceel',
        surfaceBVO: 'Oppervlakte BVO',
        grossVolume: 'Bruto inhoud',
        unitsForSale: 'Koop (aantal)',
        unitsForRent: 'Huur (aantal)',
    };

    transform(value: string): string {
        return !!this.attributeKeyTranslation[value] ? this.attributeKeyTranslation[value] : value;
    }
}
